import React, { useState } from "react";
import "../commonStyle.css";
import { isImage, isVideo } from "../../utils/commonFunctions";
import { TbArrowsMaximize } from "react-icons/tb";

/**
 * @function ImgSlider
 * @description for ImgSlider
 * @returns JSX for ImgSlider
 */

const ImgSlider = ({
  Images,
  size = "medium",
  setSelectedPostIdx = false,
  setVisible = false,
  selectedPostIdx = 0,
}) => {
  const [selectedImage, setSelectedImage] = useState(Images[0]);
  const [selectedIndex, setSelectedIndex] = useState(selectedPostIdx);

  React.useEffect(() => {
    console.log("rendering slider");
    setSelectedIndex(selectedPostIdx);
  }, [selectedPostIdx]);

  const handleThumbnailClick = (image, i) => {
    setSelectedImage(image);
    setSelectedIndex(i);
    if (setSelectedPostIdx) {
      setSelectedPostIdx(i);
    }
  };
  if (size === "small") {
    return (
      <div className="image-slider">
        {setVisible && (
          <button className="cross-btn" onClick={() => setVisible(true)}>
            <TbArrowsMaximize className="btn-icons" />
          </button>
        )}
        {isImage(selectedImage) ? (
          <div className="main-image-sm main-img-box">
            <img src={selectedImage} alt="Selected" />
          </div>
        ) : isVideo(selectedImage) ? (
          <div className="video--content--container">
            <video controls muted className="video--content">
              <source src={selectedImage} />
            </video>
          </div>
        ) : (
          <div className="main-image-sm main-img-box">
            <b>{"Invalid Formate"}</b>
          </div>
        )}
        <div className="thumbnail-container-sm">
          {Images?.length > 1 ? (
            Images.map((image, index) => {
              if (isImage(image)) {
                return (
                  <img
                    key={index}
                    src={image}
                    alt={`Thumbnail ${index + 1}`}
                    className={
                      selectedIndex === index
                        ? "thumbnail-sm active"
                        : "thumbnail-sm"
                    }
                    onClick={() => handleThumbnailClick(image, index)}
                  />
                );
              } else {
                return (
                  <video
                    key={index}
                    alt={`Thumbnail ${index + 1}`}
                    className={
                      selectedIndex === index
                        ? "thumbnail-sm active"
                        : "thumbnail-sm"
                    }
                    onClick={() => handleThumbnailClick(image, index)}
                  >
                    <source src={selectedImage} />
                  </video>
                );
              }
            })
          ) : (
            <></>
          )}
        </div>
      </div>
    );
  }
  return (
    <div className="image-slider">
      {setVisible && (
        <button className="cross-btn" onClick={() => setVisible(true)}>
          <TbArrowsMaximize className="btn-icons" />
        </button>
      )}
      {isImage(selectedImage) ? (
        <div className="main-image main-img-box">
          <img src={selectedImage} alt="Selected" />
        </div>
      ) : isVideo(selectedImage) ? (
        <div className="video--content--container-md">
          <video controls muted className="video--content">
            <source src={selectedImage} />
          </video>
        </div>
      ) : (
        <div className="main-image main-img-box">
          <b>{"Invalid Formate"}</b>
        </div>
      )}

      <div className="thumbnail-container">
        {Images.map((image, index) => {
          if (isImage(image))
            return (
              <img
                key={index}
                src={image}
                alt={`Thumbnail ${index + 1}`}
                className={
                  selectedIndex === index ? "thumbnail active" : "thumbnail"
                }
                onClick={() => handleThumbnailClick(image, index)}
              />
            );
          else {
            return (
              <video
                key={index}
                alt={`Thumbnail ${index + 1}`}
                className={
                  selectedIndex === index ? "thumbnail active" : "thumbnail"
                }
                onClick={() => handleThumbnailClick(image, index)}
              >
                <source src={image} />
              </video>
            );
          }
        })}
      </div>
    </div>
  );
};

export default ImgSlider;
